module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-container"
  }, [_c('div', {
    staticClass: "img-blur-bg",
    style: ({
      backgroundImage: ("url(" + (_vm.start.heying) + ")")
    })
  }), _vm._v(" "), _c('img', {
    staticClass: "main-img",
    attrs: {
      "src": _vm.start.heying,
      "alt": "主体图片"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-218233b3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/score/ScoreStartArmy3.vue
// module id = 2269
// module chunks = 0